<template>
  <div class="ticket-head-container">
<!--    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="filterData">查询</el-button>
      </el-form-item>
    </el-form>-->

    <el-table :data="displayData" border>
      <el-table-column prop="_checked" label="选择" width="80">
        <template #default="{row}">
          <el-checkbox v-model="row._checked" @change="(val) => handleCheckChange(row, val)" />
        </template>
      </el-table-column>
      <el-table-column prop="label" label="字段名称" />
    </el-table>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'TicketHead',
  props: {
    typeId: {
      type: Number
    },
    typeName: {
      type: String
    },
    processId:  {
      type: Number
    }
  },
  data() {
    return {
      displayData: [], // 所有字段
    }
  },
  async mounted() {
    await this.getDisplayData()
    this.filterData()
  },
  methods: {
    async getDisplayData () {
      try {
        const res = await requestTicket.post('/Ticketing/ticket-head/findAll')
        if (res && res.data){
          this.displayData = res.data.filter( v => v.typeId === this.typeId)
        }  else {
          this.displayData = []
        }
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },

    filterData() {
      if (!this.typeId) {
        return
      }
      
      // 根据typeId筛选逻辑（示例筛选逻辑，需根据实际需求调整）
      this.displayData = this.displayData.map(item => {
        console.log(this.processId)
        //逗号分割item.process
        const proces = item.process ? item.process.split(',') : []
        if (proces.find(v  => v == this.processId)) {
          return {
            ...item,
            _checked: true
          }
        } else {
          return {
            ...item,
            _checked: false
          }
        }
      })
    },

    async handleCheckChange(row, checked) {
      try {
        const proces = row.process ? row.process.split(',') : []
        if (checked) {
          proces.push(this.processId)
          row.process = proces.join(',')
        } else {
           proces.splice(proces.indexOf(this.processId), 1)
          row.process = proces.join(',')
        }
        await requestTicket.post('/Ticketing/ticket-head/save', row)
        await this.filterData() // 操作后刷新数据
      } catch (error) {
        console.error('操作失败:', error)
        row._checked = !checked // 回滚选中状态
      }
    }
  }
}
</script>

<style scoped>
.ticket-head-container {
  padding: 20px;
}
.el-table {
  margin-top: 20px;
}
</style>